import React, { ReactNode } from 'react'
import styled from 'styled-components'

const PopupContainer = styled.div<{ $top?: number; $left?: number }>`
  position: ${({ $top, $left }) => ($top && $left ? 'fixed' : 'relative')};
  top: ${({ $top }) => ($top ? `${$top}px` : 'auto')};
  left: ${({ $left }) => ($left ? `${$left}px` : 'auto')};
  transform: ${({ $top, $left }) =>
    $top && $left ? 'translateX(-50%)' : 'none'};
  background-color: ${({ theme }) => theme.forecast.glassBackground};
  backdrop-filter: blur(2rem);
  padding: 0.75rem;
  border-radius: 0.5rem;
  box-shadow: 0rem 0.25rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  z-index: 1000;
`

const MessageContainer = styled.div`
  justify-content: center;
  align-items: center;
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.defaultText};
`

const ButtonContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
`

export interface PopupProps {
  message: ReactNode
  position?: { top: number; left: number }
  actions?: ReactNode
  children?: ReactNode
}

export const Popup: React.FC<PopupProps> = ({
  message,
  position,
  actions,
  children,
}) => {
  return (
    <PopupContainer
      onClick={(e) => e.stopPropagation()}
      $top={position?.top}
      $left={position?.left}>
      <MessageContainer>{message}</MessageContainer>
      {children}
      {actions && <ButtonContainer>{actions}</ButtonContainer>}
    </PopupContainer>
  )
}
